import { OnInit } from '@angular/core';
import Dygraph from 'dygraphs';
import * as Pitchfinder from 'pitchfinder';
import WavDecoder from 'wav-decoder';
import MIDIUtils from 'midiutils';
import DynamicTimeWarping from 'dynamic-time-warping';
var ComparisonComponent = /** @class */ (function () {
    function ComparisonComponent() {
        var _this = this;
        this.fileReader = new FileReader();
        this.detectPitch = new Pitchfinder.YIN();
        this.midiTempo = 120;
        this.midiTimeSig = 4;
        this.midiFrequencies = [];
        this.showScoreChart = false;
        var self = this;
        // when the file is read
        this.fileReader.onload = function (e) {
            self.midi = JSON.parse(self.midiData);
            var trackIndex = 0;
            // if there is a bpm
            if (self.midi.header.bpm !== undefined) {
                self.midiTempo = self.midi.header.bpm;
            }
            // if there is a time signature
            if (self.midi.header.timeSignature !== undefined) {
                /* gets the time signature from
                   Header's timeSignature array,
                   depending on which track is being used
                */
                for (var index in self.midi.tracks) {
                    if (self.midi.tracks.hasOwnProperty(index)) {
                        var track = self.midi.tracks[index];
                        if (track.length !== 0) {
                            trackIndex = parseInt(index, 10);
                            self.midiTimeSig = self.midi.header.timeSignature[trackIndex];
                            break;
                        }
                    }
                }
            }
            // stores the file as an ArrayBuffer
            self.arrayBuffer = e.currentTarget.result;
            console.log('ArrayBuffer: ', self.arrayBuffer);
            console.log('Byte Length: ' + self.arrayBuffer.byteLength);
            // get audio data form file using WavDecoder
            var decodedWav = WavDecoder.decode.sync(self.arrayBuffer);
            console.log('Sample Rate: ', decodedWav.sampleRate);
            var detectors = [Pitchfinder.AMDF()];
            console.log('Tempo: ', self.midiTempo);
            console.log('Quantization: ', self.midiTimeSig);
            self.moreAccurateFrequencies = Pitchfinder.frequencies(detectors, decodedWav.channelData[0], {
                tempo: self.midiTempo,
                quantization: self.midiTimeSig,
            });
            var midiFreqRaw = self.midi.tracks[trackIndex].notes.map(function (note) { return ({
                x: _this.calcQTime(note.time, self.midiTempo, self.midiTimeSig),
                y: NaN,
                z: MIDIUtils.noteNumberToFrequency(note.midi),
            }); });
            self.midiFrequencies = [];
            var _loop_1 = function (index) {
                if (midiFreqRaw.findIndex(function (xyz) { return xyz.x === index; }) !== -1) {
                    // if theres a note at this quantized time in the midi file
                    self.midiFrequencies.push({
                        x: index,
                        y: NaN,
                        z: midiFreqRaw.find(function (xyz) { return xyz.x === index; }).z,
                    });
                }
                else {
                    // otherwise use the last one
                    self.midiFrequencies.push({
                        x: index,
                        y: NaN,
                        z: self.midiFrequencies.find(function (xyz) { return xyz.x === index - 1; }).z,
                    });
                }
            };
            // padded results for midi
            for (var index = 0; index <
                _this.calcQTime(self.midi.tracks[trackIndex].duration, self.midiTempo, self.midiTimeSig); index++) {
                _loop_1(index);
            }
            self.moreAccurateFrequencies = self.moreAccurateFrequencies.map(function (element, index) { return ({
                x: index,
                y: element,
                z: NaN,
            }); });
            // pad NaN values
            for (var index = 0; index < self.moreAccurateFrequencies.length; index++) {
                if (isNaN(self.moreAccurateFrequencies[index].y)) {
                    self.moreAccurateFrequencies[index].y =
                        index === 0 ? 0 : self.moreAccurateFrequencies[index - 1].y;
                }
            }
            var dtw = new DynamicTimeWarping(self.prepareSequence(self.midiFrequencies.map(function (xyz) { return [xyz.x, xyz.z]; })), self.prepareSequence(self.moreAccurateFrequencies.map(function (xyz) { return [xyz.x, xyz.y]; })), self.euclideanDistance);
            self.distance = dtw.getDistance();
            self.path = dtw.getPath();
            self.result = self.distance / self.path.length;
            console.log('Distance: ', self.distance);
            console.log('Path: ', self.path);
            console.log('Result: ', self.result);
            var ctx = document.getElementById('VocalChart');
            // const ctxDTW: any = document.getElementById('DTWChart');
            var options = {
                legend: 'always',
                rollPeriod: 7,
                title: 'Frequency Graph',
                labels: ['QTime', 'Vocal', 'MIDI'],
                xlabel: 'Quantized Time',
                ylabel: 'Frequency',
                colors: ['#ffd180', '#7cb342'],
            };
            var optionsDTW = {
                legend: 'always',
                rollPeriod: 7,
                title: 'DTW Graph',
                labels: ['QTime', 'DTW Path'],
                xlabel: 'Quantized Time',
                ylabel: 'Frequency',
                colors: ['#ffffff'],
            };
            var data = self.mergeFreqArray(self.moreAccurateFrequencies.map(function (xyz) { return [xyz.x, xyz.y, NaN]; }), self.midiFrequencies.map(function (xyz) { return [xyz.x, NaN, xyz.z]; }));
            var dataDTW = self.path;
            console.log('Vocal Frequencies Data: ', data);
            var g = new Dygraph(ctx, data, options);
            // const gDTW = new Dygraph(ctxDTW, dataDTW, optionsDTW);
        };
        $(function () {
            var VocalChart = document.getElementById('VocalChart');
            // create an observer instance
            var pickedObserver = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    // @ts-ignore
                    // console.log('Change Detected: ', mutation.target.innerHTML);
                    $('span#result').html(self.result);
                    if ($('span#result').html() === '') {
                        $('span#result').html('Audio Too Short');
                    }
                });
            });
            // configuration of the observer:
            var config = { attributes: true, childList: true, characterData: true };
            // pass in the target node, as well as the observer options
            pickedObserver.observe(VocalChart, config);
        });
    }
    ComparisonComponent.prototype.compare = function (vocalUrl, midiData) {
        var _this = this;
        this.vocalUrl = vocalUrl;
        this.midiData = midiData;
        // console.log('vocalUrl: ' + this.vocalUrl);
        // console.log('midiData: ' + this.midiData);
        fetch(this.vocalUrl)
            .then(function (res) { return res.blob(); }) // get's the response and returns it as a blob
            .then(function (blob) {
            console.log('Blob: ', blob);
            // reads the data from the blob as an ArrayBuffer
            _this.fileReader.readAsArrayBuffer(blob);
        })
            .catch(function (error) { return console.log(error); }); // prints out error
    };
    ComparisonComponent.prototype.calcQTime = function (time, tempo, timeSig) {
        // convert to minute
        var time2Mins = time / 60;
        // get the number of beats
        var mins2Beats = time2Mins * tempo;
        // get the Quantized time
        var qTime = mins2Beats * timeSig;
        return qTime;
    };
    ComparisonComponent.prototype.mergeFreqArray = function (vFreq, mFreq) {
        var maxLength = Math.max(vFreq.length, mFreq.length);
        var res = [];
        var _loop_2 = function (index) {
            var vI = vFreq.findIndex(function (e) { return e[0] === index; });
            var mI = mFreq.findIndex(function (e) { return e[0] === index; });
            if (mI === -1 && vI === -1) {
                res.push([index, NaN, NaN]);
            }
            else if (vI === -1) {
                res.push([index, NaN, mFreq[mI][2]]);
            }
            else if (mI === -1) {
                res.push([index, vFreq[vI][1], NaN]);
            }
            else {
                res.push([index, vFreq[vI][1], mFreq[mI][2]]);
            }
        };
        for (var index = 0; index < maxLength; index++) {
            _loop_2(index);
        }
        return res;
    };
    ComparisonComponent.prototype.euclideanDistance = function (a, b) {
        var xDiff = a[0] - b[0];
        var yDiff = a[1] - b[1];
        var ED = Math.sqrt(xDiff * xDiff + yDiff * yDiff);
        return ED;
    };
    // data is an array of arrays with the x coordinate in 0 and y in 1
    ComparisonComponent.prototype.prepareSequence = function (data) {
        var xMean = 0;
        var yMean = 0;
        var diffData = [];
        for (var i = 0; i < data.length; i++) {
            xMean = xMean + data[i][0];
            yMean = yMean + data[i][1];
        }
        xMean = xMean / data.length;
        yMean = yMean / data.length;
        for (var i = 0; i < data.length; i++) {
            diffData[i] = [data[i][0] - xMean, data[i][1] - yMean];
        }
        return diffData;
    };
    ComparisonComponent.prototype.ngOnInit = function () { };
    return ComparisonComponent;
}());
export { ComparisonComponent };
